import {
  analyticsReduxRegistry,
  DATA_LAYER_SCOPES,
  withWaitForFetch
} from "seneca-common/features/analytics";

import {
  userStatsFetchFinished,
  getUserTotalStudyTime,
  getUserSessionsCompleted,
  getUserLastStudied
} from "../selectors/state";

analyticsReduxRegistry.registerGlobalSelectorsToDataLayerScope(
  DATA_LAYER_SCOPES.STUDENT_STATS,
  {
    totalStudyTimeMs: withWaitForFetch(
      getUserTotalStudyTime,
      userStatsFetchFinished
    ),
    numberOfSessionsCompleted: withWaitForFetch(
      getUserSessionsCompleted,
      userStatsFetchFinished
    ),
    lastStudied: withWaitForFetch(getUserLastStudied, userStatsFetchFinished)
  }
);
